var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6596 4.32166C14.0391 4.32166 16.7787 7.06127 16.7787 10.4407C16.7787 13.8202 14.0391 16.5598 10.6596 16.5598C7.28014 16.5598 4.54054 13.8202 4.54054 10.4407C4.54054 7.06127 7.28014 4.32166 10.6596 4.32166ZM10.6596 3.15613C14.6828 3.15613 17.9442 6.41756 17.9442 10.4407C17.9442 14.4639 14.6828 17.7253 10.6596 17.7253C6.63643 17.7253 3.375 14.4639 3.375 10.4407C3.375 6.41756 6.63643 3.15613 10.6596 3.15613Z",
    fill: "#1F242E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1927 15.459C15.4235 15.2347 15.7924 15.24 16.0167 15.4708L20.0778 19.6505C20.3021 19.8813 20.2968 20.2502 20.066 20.4745C19.8351 20.6988 19.4662 20.6935 19.2419 20.4627L15.1808 16.283C14.9565 16.0522 14.9618 15.6832 15.1927 15.459Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.3ea302355ca7694597e91a42d550cef1.svg";
export { ForwardRef as ReactComponent };